import React from "react";
import { withTranslation } from "react-i18next";
import { BusinessAdministrationPanelView } from "../../views";
import {
  LocalStorageService,
  ClientCompanyService,
} from "../../../services/index";
import moment from "moment";
import "moment/locale/es";
import { NIL as NIL_UUID } from "uuid";
import { businessIconDefault } from "../../../assets/logos/icons";

import BusinessAdministrationValidator from "../../../validators/business-administration.validator";

/**
 * @class BusinessAdministrationAction
 * @extends {React.Component}
 * @status no delete
 * @description classs defining the actions of business administration
 */
class BusinessAdministrationAction extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      title: props.t("configurationPanelView.titleContracts"),
      clientCompany: [],
      token: "",
      shouldRefresh: false,
      client: {},
      message: " ",
      showLoadingRequesting: false,
      showCompletedRequesting: false,
      showErrorRequesting: false,
      showWarningRequesting: false,
      userInformation: "",
      imageProfile: "",
      optionsTypeBusiness: [
        { typeOfCompany: "A.C." },
        { typeOfCompany: "S. de R.L. de C.V." },
        { typeOfCompany: "S.A. de C.V." },
        { typeOfCompany: "S.A.B. de C.V." },
        { typeOfCompany: "S.A.S. de C.V." },
        { typeOfCompany: "S.C." },
        { typeOfCompany: "S.A.P.I. de C.V." },
        { typeOfCompany: "A.B.P." }
      ],
      optionsBusinessTurnover: [
        { turnOfTheCompany: "Comercial" },
        { turnOfTheCompany: "Industrial" },
        { turnOfTheCompany: "Servicio" },
      ],
      optionsFilter: [
        {
          active: NIL_UUID,
          status: "Todos",
        },
        {
          active: true,
          status: "Activo",
        },
        {
          active: null,
          status: "Inactivo",
        },
      ],
    };
  }

  token = {};
  url = process.env.REACT_APP_ETICKET_API;
  localStorageService = new LocalStorageService();
  clientCompanyService = new ClientCompanyService(this.url);
  validators = BusinessAdministrationValidator(this.props.t);

  async componentDidMount() {
    this.setState({ loading: true });
    this.token = this.localStorageService.getLocalStorageItem("token").idToken;
    this.user = this.localStorageService.getLocalStorageItem("user");
    try {
      let timezone = await this.localStorageService.getLocalStorageItem("timezone");
      let userInformation = this.user.userMetaData.userA3Cloud;
      let clientsCompanyInfo = await this.clientCompanyService.getClientCompany(
        userInformation.clientId,
        this.token,
        timezone
      );
      moment.locale("es");
      clientsCompanyInfo.data.map((client) => {
        client.clientName = client.company.businessName;
        let dateModification = client.updatedDate.split("T")[0];
        client.lastModificationDate = moment(dateModification)
          .format("DD-MMM-YYYY")
          .replace(/\./g, "");
        client.status = client.company.status;
        client.imgProfile =
          client.company.logo === null
            ? businessIconDefault
            : client.company.logo;
        client.companyName = client.company.companyName;
        client.turnOfTheCompany = client.company.turnOfTheCompany;
        client.typeOfCompany = client.company.typeOfCompany;

        return clientsCompanyInfo.data.data;
      });
      this.setState({
        userInformation: userInformation,
        clientCompany: clientsCompanyInfo.data,
        token: this.token,
        loading: false,
        imageProfile: businessIconDefault,
      });
    } catch (error) {
      this.props.history.push("/configuration");
      this.setState({
        clientCompany: [],
        loading: false,
      });
    }
  }

  /**
   * @description Function to change image profile
   * @status no delete
   * @param {*} e
   * @memberof BusinessAdministrationAction
   */
  onChangeImgProfile = async (e) => {
    let fileIn = document.getElementById("fileUploadImgProfile");
    let fileOut = document.getElementById("imgProfile");

    if (e.target.files && e.target.files[0]) {
      let fileReader = new FileReader();
      fileReader.onload = (e) => (fileOut.src = e.target.result);
      fileReader.readAsDataURL(e.target.files[0]);
      this.setState({
        imageProfile: e.target.files[0],
      });
    } else {
      this.setState({
        imageProfile: businessIconDefault,
      });
    }
  };


  /**
   * @description function to forcefully re render component
   * @status no delete
   * @memberof BusinessAdministrationAction
   */
  forceRefresh = () => {
    this.setState(({ shouldRefresh }) => ({ shouldRefresh: !shouldRefresh }));
  };


  /**
   * @status no delete
   * @param {*} value
   * @memberof BusinessAdministrationAction
   */
  toggleLoadingRequesting = (value) => {
    this.setState({
      showLoadingRequesting: value,
    });
  };


  /**
   * @status no delete
   * @param {*} value
   * @param {*} message
   * @param {*} clientCompany
   * @memberof BusinessAdministrationAction
   */
  toggleCompletedRequesting = (value, message, clientCompany) => {
    this.setState(
      {
        showCompletedRequesting: value,
        message: message,
      },
      () => {
        setTimeout(() => {
          this.setState({
            showCompletedRequesting: false,
            message: "",
            clientCompany: clientCompany,
          });
        }, 4000);
      }
    );
  };


  /**
   * @status no delete
   * @param {*} value
   * @param {*} message
   * @memberof BusinessAdministrationAction
   */
  toggleCompleted = (value, message) => {
    this.setState(
      {
        showCompletedRequesting: value,
        message: message,
      },
      () => {
        setTimeout(() => {
          this.setState({
            showCompletedRequesting: false,
            message: ""
          });
        }, 4000);
      }
    );
  }


  /**
   * @status no delete
   * @memberof BusinessAdministrationAction
   */
  toggleCompletedModel = () => {
    this.setState({ showCompletedRequesting: false })
  }

  /**
  * @status no delete
  * @memberof BusinessAdministrationAction
  */
  resetImageProfile = () => {
    this.setState({ imageProfile: "/static/media/icon_empresas.dfb0bda7.svg" })
  }


  /**
   * @status no delete
   * @param {*} value
   * @param {*} message
   * @memberof BusinessAdministrationAction
   */
  toggleErrorRequesting = (value, message) => {
    this.setState(
      {
        showErrorRequesting: value,
        message: message,
      },
      () => {
        setTimeout(() => {
          this.setState({ showErrorRequesting: false, message: "" });
        }, 5000);
      }
    );
  };


  /**
   * @status no delete
   * @param {*} value
   * @param {*} message
   * @memberof BusinessAdministrationAction
   */
  toggleWarningRequesting = (value, message) => {
    this.setState(
      {
        showWarningRequesting: value,
        message: message,
      },
      () => {
        setTimeout(() => {
          this.setState({ showWarningRequesting: false, message: "" });
        }, 5000);
      }
    );
  };

  render() {
    return (
      <BusinessAdministrationPanelView
        {...this.state}
        forceRefresh={this.forceRefresh}
        validators={this.validators}
        onChangeImgProfile={this.onChangeImgProfile}
        toggleCompletedRequesting={this.toggleCompletedRequesting}
        toggleCompleted={this.toggleCompleted}
        toggleCompletedModel={this.toggleCompletedModel}
        toggleErrorRequesting={this.toggleErrorRequesting}
        toggleLoadingRequesting={this.toggleLoadingRequesting}
        toggleWarningRequesting={this.toggleWarningRequesting}
        resetImageProfile={this.resetImageProfile}
      />
    );
  }
}

export default withTranslation()(BusinessAdministrationAction);
